module.exports = __webpack_public_path__ + "img/iconruzhi.b1a04314.png";